import { XIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import React from 'react';

export default function Banner({ text, buttonText, buttonLink, setShowBanner, hideButton }) {
  return (
    <div className='relative z-20 bg-[#306CA3]'>
      <div className='max-w-8xl mx-auto py-3 px-3 sm:px-6 lg:px-8'>
        <div className='pr-16 sm:text-center sm:px-16'>
          <p className='font-medium text-white'>
            <span className='inline'>{text}</span>
            {!hideButton && (
              <Link href={buttonLink}>
                <span className='block sm:ml-2 sm:inline-block text-white font-bold underline cursor-pointer'>
                  {' '}
                  {buttonText} <span aria-hidden='true'>&rarr;</span>
                </span>
              </Link>
            )}
          </p>
        </div>
        <div className='absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start'>
          <button
            type='button'
            className='flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white'
            onClick={() => setShowBanner(false)}
          >
            <span className='sr-only'>Dismiss</span>
            <XIcon className='h-6 w-6 text-white' aria-hidden='true' />
          </button>
        </div>
      </div>
    </div>
  );
}
